export const AGING_BALANCE_COLOR_MAP = {
    "<0": 'status-ok',
    "0+": 'status-warning-1',
    "30+": 'status-warning-2',
    "60+": 'status-critical-1',
    "90+": 'status-critical-2',
};

// Keyed by each bucket's own key in companies/{id}/summary -> aging_balances ("0", "1", "31",
// "61", "91"), not by its label. The label is display copy: it read "Due" for the bucket that
// is NOT due, the backend has corrected it to "Not yet due", and anything keyed on the old
// spelling silently lost its fill. The keys have never changed.
export const AGING_BALANCE_GRAPH_COLOR_MAPPING = {
    "placeholder": "piechart-secondary",
    "0": AGING_BALANCE_COLOR_MAP["<0"],
    "1": AGING_BALANCE_COLOR_MAP["0+"],
    "31": AGING_BALANCE_COLOR_MAP["30+"],
    "61": AGING_BALANCE_COLOR_MAP["60+"],
    "91": AGING_BALANCE_COLOR_MAP["90+"],
};

export const OVERDUE_COLOR_MAP = {
    "90+": "invoice-overdue-90+",
    "60+": "invoice-overdue-60+",
    "30+": "invoice-overdue-30+",
    "0+": "invoice-overdue",
    "<0": "invoice-not-yet-due",
};
